import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, useSearchParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../components/imports'

import { APP_NAME, PLANTSITTING_COM } from '../constants/general'

import { Context } from '../class/Context'

import Func from '../class/Func'

import Paiements_Class from '../class/Paiements_Class'

import User from '../class/User'

import PlantSitting from '../class/PlantSitting';
import Moment from 'react-moment';

function Payer() {

    const navigate = useNavigate()

    const context = useContext(Context)

    const [flash, setFlash] = useState({})

    const [prix, setPrix] = useState(0)
    const [com, setCom] = useState(0)

    const [cartes, setCartes] = useState(false)

    const [get_params] = useSearchParams()

    const [infos, setInfos] = useState(false)

    const [valide, setValide] = useState(false)

    const [discussion, setDiscussion] = useState(false)

    const [annonce, setAnnonce] = useState(false)

    const myInfos = async () => {

        let results = await User.session(true)

        if (results.success) {

            setInfos(results.data)

        }

    }

    const getCartes = async () => {

        let results = await Paiements_Class.user_cards()

        if (results.success) {

            setCartes(results.data)

        } else {

            setCartes(results.message)

        }

    }

    const getDiscussion = async (reservation) => {

        let results = await PlantSitting.post('reservation', { reservation: reservation })

        if (results.success) {

            setDiscussion(results)

            setAnnonce(results.annonce)

            setPrix(results.prix)

            setCom(results.com)

            setValide(true)

        } else {

            navigate('/404')

        }

    }

    const payer = async (e, reservation) => {

        e.preventDefault()

        let inputs = e.target

        if (inputs.use_card == undefined) {

            setFlash({ message: "Tu dois ajouter une carte de paiement", type: "error" })

            return false

        }

        if (inputs.use_card.value !== "" && valide) {

            setValide(false)

            let results = await PlantSitting.post('payer', { card_id: inputs.use_card.value, reservation: discussion.reservation })

            setValide(true)

            if (results.success) {

                navigate('/mon-profile/discussion/' + results.discussion_id)

                setFlash({ message: "Pay", type: "succes" })

            } else {

                setFlash({ message: results.message, type: "error" })

            }

        } else {

            setFlash({ message: "Veuillez ajouter selectionner votre moyen de paiement pour continuer", type: "error" })

        }

    }

    useEffect(() => {

        let reservation = get_params.get("reservation")

        if (reservation == null) reservation = 0

        window.scrollTo(0, 0)

        if (context.session === false) {

            Func.session(context, navigate, '/connexion', true)

        } else {

            Func.getFlash(setFlash)

            getDiscussion(reservation)

            myInfos()

            getCartes()

            document.title = "Payer une réservation - " + APP_NAME

        }

    }, [])

    return (

        <div>

            <Header />

            <div className="profil">

                <HeaderBox />

                <form method='POST' onSubmit={(e) => payer(e)} className='c content flex ai-start jc-center'>

                    <div className="col-5 pos-r">

                        <div className="paiements m_p10 m_mt_10">

                            <div className="bg6 p20 br10 mb20">

                                <h2 className='fw5 mb20 d-block'>Détails de la commande</h2>

                                {

                                    annonce

                                        ?

                                        <>

                                            <div className='flex m_flex ai-center mb20'>

                                                <div className="flex m_flex ai-center">
                                                    <img src={Func.avatar(annonce.avatar)} className='br10 mr20 w_h_60' style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                                    <div>
                                                        <p className='fz12 fw5'>{annonce.name}</p>
                                                        <p>{annonce.titre}</p>
                                                    </div>
                                                </div>

                                                {/* <p className='fz12 fw7 m_col_3 ta-end'>{prix} €</p> */}

                                            </div>

                                            <p>Type de réservation : <strong>{discussion.annonce.categorie_id == 1 ? 'Gardiennage' : discussion.annonce.categorie_id == 2 ? 'Arrosage' : 'Jardinage'}</strong></p>
                                            
                                            {/* <p>Type de réservation : <strong>
                                                {discussion.reservation_type == 1 && 'Gardiennage'}
                                                {discussion.reservation_type == 2 && 'Arrosage'}
                                                {discussion.reservation_type == 3 && 'Jardinage'}
                                            </strong></p> */}

                                            <p>Date de début : <strong><Moment locale="fr" format='DD MMMM Y'>{discussion.date_debut}</Moment></strong></p>
                                            <p>Date de fin : <strong><Moment locale="fr" format='DD MMMM Y'>{discussion.date_fin}</Moment></strong></p>
                                            <p className='mb20'>Nombre de jours : <strong>{discussion.nbrjours} jours</strong></p>

                                            <Link to={'#'} className='fz08 cl3' onClick={ e => navigate(-1) }>Plus de détails</Link>
                                        </>

                                        :

                                        <div className='flex jc-center mt50 mb50'>
                                            <div className="lds-dual-ring col"></div>
                                        </div>

                                }

                            </div>

                            <div className="bg6 p20 br10 mb20 m_mb_0">

                                <h2 className='fw5 mb30 d-block'>Options de paiement</h2>

                                <div>

                                    {

                                        cartes

                                            ?

                                            typeof cartes == "string"

                                                ?

                                                <p className='fz09'>{cartes}</p>

                                                :

                                                cartes.map(carte =>

                                                    <label className="flex m_flex ai-center jc-start mb20" key={carte.id}>

                                                        <input type="radio" className='mr10' name='use_card' value={carte.id} required={true} />

                                                        <div>
                                                            <span className='d-block'>{carte.card.brand} : ****{carte.card.last4}, Exp {carte.card.exp_month  + '/' + carte.card.exp_year}</span>
                                                        </div>

                                                    </label>

                                                )

                                            :

                                            <div className='mt50 mb50'>
                                                <div className="lds-dual-ring col"></div>
                                            </div>

                                    }

                                    <div>
                                        <Link to={'/mon-profile/paiements'} className='mt20 btn bg4 cl1'>Ajouter</Link>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className='col-3 m_p10'>

                        <div className='ml20 bg7 br10 p20 m_ml_0'>

                            <h3 className='mb30'>Résumé de la commande</h3>

                            {

                                discussion

                                    ?

                                    <div className='fz08'>

                                        <div className='flex m_flex mb5'>
                                            <strong>Réservation</strong>
                                            <p>{prix} €</p>
                                        </div>

                                        <div className='flex m_flex mb5'>
                                            <strong>Frais de service</strong>
                                            <p>{(com).toFixed(2)} €</p>
                                        </div>

                                        <div className='flex m_flex mb5'>
                                            <strong>Total</strong>
                                            <strong>{(discussion.prix_total).toFixed(2)} €</strong>
                                        </div>

                                    </div>

                                    :

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                            }

                            {flash !== '' && <p className={flash.type + " fz08 mb0"}>{flash.message}</p>}

                            {

                                valide

                                    ?

                                    <input type="submit" className='btn bg4 col-10 cl1 ta-center mt20 brc1solid brc4' value="Payer" />

                                    :

                                    <div className='flex jc-center mt10 mb30'>
                                        <div className="lds-dual-ring"></div>
                                    </div>

                            }

                            <p className='fz07 d-block ta-center mt5'>Paiement crypté et sécurisé</p>

                            <div className='flex m_flex jc-center mt10'>
                                <img src="/image/powered-by-stripe.svg" className='col-3 m_col_25' />
                            </div>

                        </div>

                    </div>

                </form>

            </div>

            <Footer />

        </div>

    )

}

export default Payer